export const formatFilterValue = (value: string, isDate?: boolean): Date | number =>
  isDate ? new Date(value) : Number(value) || 0;
